// Payroll's own look — Ara's payroll spec, "Brand" and "Navigation (inside the Payroll page only)".
//
// ⛔ Spec §0 rule 3: payroll styling is scoped to the Payroll page. The colours live here once; the
// scoped stylesheet (apps/web/src/pages/admin/payroll/brand/payroll.css) repeats them as CSS variables
// under `.payroll-scope`, and a test holds the two together and proves nothing in that file can reach
// another page.
export const PAYROLL_BRAND = {
    /** Top bar, buttons, links, employee bars. */
    blue: '#0B4FC0',
    /** Active tab underline, badges, tile icons, contractor bars. */
    orange: '#FFB23F',
    darkBlue: '#78A2FF',
    darkOrange: '#FFBD4C',
    headingFont: 'Poppins',
    bodyFont: 'Nunito Sans',
    numberFont: 'IBM Plex Mono',
};
/** The wrapper class every payroll style hangs off. */
export const PAYROLL_SCOPE_CLASS = 'payroll-scope';
/** "3", "99+", or null when nothing is waiting. */
export function navBadge(count) {
    if (!Number.isFinite(count) || count < 1)
        return null;
    return count > 99 ? '99+' : String(Math.floor(count));
}
const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;
/**
 * Payroll's sub-navigation. The spec's sections, in the spec's order — Home · Pay runs · People ·
 * Adjustments · Payments · Settings — with the sections that were already on the page (Hours & run,
 * Attendance, Reports) kept where they were (spec §0 rule 8: extend, don't remove).
 */
export function payrollNavItems(counts) {
    const item = (key, label, count = 0, what) => {
        const badge = navBadge(count);
        return { key, label, badge, badgeLabel: badge && what ? plural(Math.floor(count), what[0], what[1]) : null };
    };
    return [
        item('home', 'Home'),
        item('overview', 'Hours & run'),
        item('attendance', 'Attendance'),
        item('runs', 'Pay runs'),
        // Staff salary invoices (My Invoices, 3 Nov 2026): waiting for approval, or approved and not yet encoded.
        item('invoices', 'Invoices', counts.invoices ?? 0, ['invoice waiting', 'invoices waiting']),
        item('people', 'People', counts.inbox, ['change to review', 'changes to review']),
        item('adjustments', 'Adjustments', counts.claims, ['reimbursement waiting', 'reimbursements waiting']),
        item('payments', 'Payments'),
        item('reports', 'Reports'),
        item('settings', 'Settings'),
    ];
}
export const PAYROLL_SECTION_KEYS = payrollNavItems({ inbox: 0, claims: 0 }).map((i) => i.key);
//# sourceMappingURL=payrollBrand.js.map